/**
 * created on: 2019.04.04
 * 电视管理内部导航
 */
"use strict"
angular.module('televisionManageNavModule', [])
    .directive('televisionManageNav', ['$state', '$location', '$stateParams', 'televisionManageService', '$timeout', function($state, $location, $stateParams, televisionManageService, $timeout) {
        return {
            restirct: "A",
            scope: true,
            replace: false,
            templateUrl: "./manageConfig/productManageMent/television/televisionManageNav/televisionManageNav_tpl.html",
            link: function($scope, $element, $attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus 初始化状态]
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        moduleList: [{
                            name: '栏目管理',
                            value: 0,
                            show: true,
                            router: 'channelmanage'
                        }, {
                            name: '分发配置管理',
                            value: 1,
                            show: false,
                            router: 'distributionconfiguration'
                        }],
                        selectedModule: $location.path().split('/')[5],
                    };
                    /*televisionManageService.getChannelAccessAuthority($state.params.siteid).then(function(data) {
                        
                    });*/
                }

                /**
                 * [initData 初始化数据]
                 * @return {[type]} [description]
                 */
                function initData() {
                    if (!$scope.status.selectedModule) {
                        $timeout(function() {
                            var li = $element.find('li');
                            if (li.length > 0) li.eq(0).click();
                        }, 100);
                    }
                }

                /**
                 * [changeModule 更改模块]
                 * @param  {[type]} module [description]
                 * @return {[type]}        [description]
                 */
                $scope.changeModule = function(module) {
                    $scope.status.selectedModule = module.router;
                    var router = 'manageconfig.productmanage.television.manage.' + module.router;
                    $timeout(function() {
                        $state.go(router, { reload: router });
                    }, 200);
                };
            }
        }
    }])